import {useRouter} from 'next/router';
import {useState} from 'react';
import {useGetLinkNotices} from '../../core/repositories/linkNoticesRepository';
import {useAuth} from '../../core/usecases/auth/AuthContext';

const useLinkNoticeData = () => {
  const {status} = useAuth();
  const router = useRouter();
  const isTopPage = router.pathname === '/';
  const {data} = useGetLinkNotices({
    config: {enabled: status === 'authenticated' && isTopPage},
  });

  const linkNotice = data?.linkNotice;
  const isShow = isTopPage && Boolean(linkNotice);

  return {linkNotice, isShow};
};

export const useHandleLinkNotice = () => {
  const {linkNotice, isShow} = useLinkNoticeData();
  const [isOpen, setIsOpen] = useState(true);

  return {
    linkNotice,
    isOpen,
    isShow,
    closePopup: () => setIsOpen(false),
  };
};

export const useLinkNoticeVisible = (): boolean => {
  const {isShow} = useLinkNoticeData();
  return isShow;
};
